<div *ngIf="jsonData">
	<div [style]="getTextStyle(jsonData.title)">
		{{
			jsonData.title.text.toString().replace("{authuser}", auth_user.nome)
		}}
	</div>
	<div [style]="getTextStyle(jsonData.description)" class="mt-5">
		{{ jsonData.description.text }}
	</div>
	<div class="row mt-5">
		<div class="col-6" *ngFor="let block of jsonData.blocks; let i = index">
			<nb-card
				*ngIf="block.type == blockTypes.synthesis"
				class="synthesis-card"
			>
				<nb-card-body class="m-4">
					<div
						class="h-100 d-flex flex-column justify-content-between"
					>
						<div class="d-flex justify-content-between">
							<div class="d-flex align-items-center flex-grow-1">
								<i
									[class]="block.icon.class"
									[style]="getIconStyle(block.icon)"
								></i>
								<div
									class="ml-3 d-flex flex-column justify-content-center"
								>
									<div [style]="getTextStyle(block.title)">
										{{
											block.title.key
												? stats[block.title.key]
													? stats[block.title.key]
													: "I distretti presso i quali operi"
												: block.title.text
														.toString()
														.replace(
															"{authuser}",
															auth_user.nome +
																" " +
																auth_user.cognome
														)
										}}
									</div>
									<div [style]="getTextStyle(block.subtitle)">
										{{
											block.subtitle.key
												? stats[block.subtitle.key]
													? stats[block.subtitle.key]
													: "Le aziende presso le quali operi"
												: block.subtitle.text
										}}
									</div>
								</div>
							</div>
							<div [style]="getTextStyle(block.hintText)">
								{{ block.hintText.text }}
							</div>
						</div>
						<div class="mt-4 d-flex justify-content-between">
							<div
								class="d-flex flex-column"
								*ngFor="let numberTotal of block.numberTotals"
							>
								<div [style]="getTextStyle(numberTotal.title)">
									{{ numberTotal.title.text }}
								</div>
								<div
									class="mt-3"
									[style]="getTextStyle(numberTotal.value)"
								>
									{{
										numberTotal.value.key
											? stats[numberTotal.value.key]
											: numberTotal.value.text
									}}
								</div>
							</div>
						</div>
						<div class="d-flex mt-5">
							<div
								class="gauge-chart"
								echarts
								[options]="
									generateGaugeOptions(block.percentTotal)
								"
							></div>
							<div
								class="ml-3 d-flex flex-column justify-content-between py-2"
							>
								<div
									[style]="
										getTextStyle(block.percentTotal.title)
									"
								>
									{{ block.percentTotal.title.text }}
								</div>
								<div class="d-flex">
									<div
										class="mr-3 d-flex align-items-center"
										*ngFor="
											let stat of block.percentTotal.stats
										"
									>
										<div
											class="pill"
											[class.pill-negative]="
												isPillNegativeClass(stat)
											"
										>
											{{
												stat.value.key
													? stats[stat.value.key]
													: stat.value.text
											}}
										</div>
										<div
											[style]="getTextStyle(stat.title)"
											class="ml-2"
										>
											{{ stat.title.text }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</nb-card-body>
			</nb-card>

			<nb-card *ngIf="block.type == blockTypes.chart">
				<nb-card-body class="m-4">
					<div class="d-flex justify-content-between">
						<div
							class="flex-grow-1"
							[style]="getTextStyle(block.title)"
						>
							{{ block.title.text }}
						</div>

						<div [style]="getTextStyle(block.hintText)">
							{{ block.hintText.text }}
						</div>
					</div>
					<div [id]="'barchart_' + i" class="bar-chart"></div>
				</nb-card-body>
			</nb-card>
		</div>
	</div>
</div>
